package com.arena_web.data.api

import com.arena_web.data.dto.NewsArticleDto
import com.arena_web.data.dto.NewsPageDto
import com.arena_web.data.http.ApiResponse
import com.arena_web.data.http.apiGet
import io.ktor.client.*

class NewsApi(private val client: HttpClient) {

    /** params: page, size, sport, sort (new|popular), date (yyyy-MM-dd). */
    suspend fun getNews(params: Map<String, String> = emptyMap()): ApiResponse<NewsPageDto> {
        return client.apiGet("v1/news", params)
    }

    suspend fun getArticle(id: String, locale: String? = null): ApiResponse<NewsArticleDto> {
        val params = locale?.let { mapOf("locale" to it) } ?: emptyMap()
        return client.apiGet("v1/news/$id", params)
    }
}
